var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProofOfAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "117px",
    height: "120px",
    viewBox: "0 0 117 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "proof of address") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "path-1",
    cx: 58.2352941,
    cy: 60,
    rx: 58.2352941,
    ry: 60
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 340.496623 188.662189 340.496623 188.662189 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "door-knocker",
    transform: "translate(-130.000000, -651.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(23.000000, 313.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "proof-of-address",
    transform: "translate(107.000000, 338.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-106",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#D8D8D8",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.365477, 10.819672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00021852721,171.824447 L0.00021852721,102.913434 L20.1626316,102.913434 L20.1626316,161.397494 C20.1626316,167.131979 15.6260067,171.824447 10.0808787,171.824447 L0.00021852721,171.824447 Z",
    id: "Fill-1",
    stroke: "none",
    fill: "#F0F7FB",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4",
    stroke: "none",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "0 157.166023 163.634267 157.166023 163.634267 11.4859223 0 11.4859223"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "163.634705 3.62660395 158.180265 -0.000113017045 152.730197 3.62660395 147.281221 -0.000113017045 141.828967 3.62660395 136.37562 -0.000113017045 130.925552 3.62660395 125.47439 -0.000113017045 120.019951 3.62660395 114.56879 -0.000113017045 109.114351 3.62660395 103.662097 -0.000113017045 98.2087505 3.62660395 92.755404 -0.000113017045 87.2998722 3.62660395 81.8465256 -0.000113017045 76.3920865 3.62660395 70.9354621 -0.000113017045 65.4810229 3.62660395 60.0254911 -0.000113017045 54.5699593 3.62660395 49.118798 -0.000113017045 43.6654515 3.62660395 38.2088271 -0.000113017045 32.7532953 3.62660395 27.2977635 -0.000113017045 21.8400464 3.62660395 16.3856073 -0.000113017045 10.9257049 3.62660395 5.46252467 -0.000113017045 0.00043705442 3.62660395 0.00043705442 11.4858092 163.634705 11.4858092"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    stroke: "none",
    fill: "#A9D3E1",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "79.1877051 116.212037 106.665316 116.212037 106.665316 110.166755 79.1877051 110.166755"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    stroke: "none",
    fill: "#A9D3E1",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "124.479655 100.344444 152.5309 100.344444 152.5309 94.2991619 124.479655 94.2991619"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    stroke: "none",
    fill: "#A9D3E1",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "11.1044602 100.344444 81.8176801 100.344444 81.8176801 94.2991619 11.1044602 94.2991619"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    stroke: "none",
    fill: "#A9D3E1",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "124.479655 116.212037 152.5309 116.212037 152.5309 110.166755 124.479655 110.166755"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    stroke: "none",
    fill: "#A9D3E1",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "11.1033675 116.212037 73.0623874 116.212037 73.0623874 110.166755 11.1033675 110.166755"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    stroke: "none",
    fill: "#A9D3E1",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "124.479655 132.07963 152.5309 132.07963 152.5309 126.034348 124.479655 126.034348"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    stroke: "none",
    fill: "#A9D3E1",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "11.1033675 132.07963 57.8561715 132.07963 57.8561715 126.034348 11.1033675 126.034348"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    stroke: "none",
    fill: "#A9D3E1",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "63.4078553 132.07963 110.160659 132.07963 110.160659 126.034348 63.4078553 126.034348"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    stroke: "none",
    fill: "#A9D3E1",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "132.368487 147.947223 152.5309 147.947223 152.5309 141.901941 132.368487 141.901941"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    stroke: "none",
    fill: "#A9D3E1",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "11.1044602 147.947223 81.8176801 147.947223 81.8176801 141.901941 11.1044602 141.901941"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    stroke: "none",
    fill: "#F4F4F4",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "25.0279214 329.823293 188.662189 329.823293 188.662189 102.913321 25.0279214 102.913321"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-17",
    stroke: "none",
    fill: "#F4F4F4",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "25.027375 336.870132 30.4818142 340.496849 35.9318828 336.870132 41.3808588 340.496849 46.8331127 336.870132 52.2853666 340.496849 57.7365278 336.870132 63.1876891 340.496849 68.6421282 336.870132 74.0932895 340.496849 79.546636 336.870132 84.9999826 340.496849 90.4533291 336.870132 95.9066756 340.496849 101.361115 336.870132 106.815554 340.496849 112.269993 336.870132 117.725525 340.496849 123.181057 336.870132 128.636588 340.496849 134.09212 336.870132 139.543282 340.496849 144.996628 336.870132 150.453252 340.496849 155.908784 336.870132 161.364316 340.496849 166.822033 336.870132 172.276472 340.496849 177.736375 336.870132 183.198462 340.496849 188.661643 336.870132 188.661643 329.012056 25.027375 329.012056"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-18",
    stroke: "none",
    fill: "#A9D3E1",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "90.5718801 32.4912702 152.5309 32.4912702 152.5309 26.4459885 90.5718801 26.4459885"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-19",
    stroke: "none",
    fill: "#A9D3E1",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "75.8649989 307.934152 137.824019 307.934152 137.824019 301.88887 75.8649989 301.88887"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-20",
    stroke: "none",
    fill: "#A9D3E1",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "149.506483 124.221555 177.557729 124.221555 177.557729 118.176273 149.506483 118.176273"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-21",
    stroke: "none",
    fill: "#A9D3E1",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "36.1312889 124.221555 98.0903087 124.221555 98.0903087 118.176273 36.1312889 118.176273"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    stroke: "none",
    fill: "#A9D3E1",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "104.214534 124.221555 131.693238 124.221555 131.693238 118.176273 104.214534 118.176273"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    stroke: "none",
    fill: "#A9D3E1",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "104.214534 171.824334 131.693238 171.824334 131.693238 165.780182 104.214534 165.780182"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-24",
    stroke: "none",
    fill: "#A9D3E1",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "157.395316 140.089148 177.557729 140.089148 177.557729 134.043866 157.395316 134.043866"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-25",
    stroke: "none",
    fill: "#A9D3E1",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "36.1312889 140.089148 82.8840928 140.089148 82.8840928 134.043866 36.1312889 134.043866"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-26",
    stroke: "none",
    fill: "#A9D3E1",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "149.506483 155.956741 177.557729 155.956741 177.557729 149.911459 149.506483 149.911459"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-27",
    stroke: "none",
    fill: "#A9D3E1",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "36.1301963 155.956741 106.844509 155.956741 106.844509 149.911459 36.1301963 149.911459"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-28",
    stroke: "none",
    fill: "#A9D3E1",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "149.506483 171.824334 177.557729 171.824334 177.557729 165.780182 149.506483 165.780182"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-29",
    stroke: "none",
    fill: "#A9D3E1",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "36.1312889 171.824334 98.0903087 171.824334 98.0903087 165.780182 36.1312889 165.780182"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-30",
    stroke: "none",
    fill: "#A9D3E1",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "149.506483 187.693057 177.557729 187.693057 177.557729 181.647775 149.506483 181.647775"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-31",
    stroke: "none",
    fill: "#A9D3E1",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "36.1312889 187.693057 82.8840928 187.693057 82.8840928 181.647775 36.1312889 181.647775"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-32",
    stroke: "none",
    fill: "#A9D3E1",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "88.4357766 140.089148 135.188581 140.089148 135.188581 134.043866 88.4357766 134.043866"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-33",
    stroke: "none",
    fill: "#A9D3E1",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "88.4357766 187.693057 135.188581 187.693057 135.188581 181.647775 88.4357766 181.647775"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-34",
    stroke: "none",
    fill: "#A9D3E1",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "157.395316 203.56065 177.557729 203.56065 177.557729 197.515369 157.395316 197.515369"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-35",
    stroke: "none",
    fill: "#A9D3E1",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "149.506483 279.182615 177.557729 279.182615 177.557729 273.137334 149.506483 273.137334"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-36",
    stroke: "none",
    fill: "#A9D3E1",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "36.1301963 203.56065 106.844509 203.56065 106.844509 197.515369 36.1301963 197.515369"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-37",
    stroke: "none",
    fill: "#A9D3E1",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "104.214534 217.891212 131.693238 217.891212 131.693238 211.84593 104.214534 211.84593"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-38",
    stroke: "none",
    fill: "#A9D3E1",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "149.506483 217.891212 177.557729 217.891212 177.557729 211.84593 149.506483 211.84593"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-39",
    stroke: "none",
    fill: "#A9D3E1",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "36.1312889 217.891212 98.0903087 217.891212 98.0903087 211.84593 36.1312889 211.84593"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-40",
    stroke: "none",
    fill: "#A9D3E1",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "149.506483 233.758805 177.557729 233.758805 177.557729 227.713523 149.506483 227.713523"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-41",
    stroke: "none",
    fill: "#A9D3E1",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "36.1312889 233.758805 82.8840928 233.758805 82.8840928 227.713523 36.1312889 227.713523"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-42",
    stroke: "none",
    fill: "#A9D3E1",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "88.4357766 233.758805 135.188581 233.758805 135.188581 227.713523 88.4357766 227.713523"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-43",
    stroke: "none",
    fill: "#A9D3E1",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "157.395316 249.626398 177.557729 249.626398 177.557729 243.581116 157.395316 243.581116"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-44",
    stroke: "none",
    fill: "#A9D3E1",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "36.1301963 249.626398 106.844509 249.626398 106.844509 243.581116 36.1301963 243.581116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5422794,85.8095475 L152.969812,85.8095475",
    id: "Stroke-45",
    stroke: "#A9D3E1",
    strokeWidth: 2,
    fill: "none",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1308518,262.484234 L177.558384,262.484234",
    id: "Stroke-46",
    stroke: "#A9D3E1",
    strokeWidth: 2,
    fill: "none",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1308518,289.836732 L177.558384,289.836732",
    id: "Stroke-47",
    stroke: "#A9D3E1",
    strokeWidth: 2,
    fill: "none",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-48",
    stroke: "none",
    fill: "#BAD2DB",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "25.027375 102.913321 25.027375 171.824334 0.000546318025 171.824334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3158073,43.9523287 L15.3158073,37.0944545 L16.2500111,37.0944545 L18.3751882,40.5640777 C18.8668745,41.3676289 19.2503897,42.090938 19.5650689,42.7927739 L19.5847364,42.7826023 C19.5060666,41.8660341 19.4863991,41.0319683 19.4863991,39.9639572 L19.4863991,37.0944545 L20.2938571,37.0944545 L20.2938571,43.9523287 L19.4273968,43.9523287 L17.3229797,40.4725339 C16.8607947,39.7096689 16.4171844,38.9264608 16.0828378,38.1839388 L16.0533366,38.1929801 C16.1025053,39.0586907 16.1221727,39.882585 16.1221727,41.0217968 L16.1221727,43.9523287 L15.3158073,43.9523287 Z",
    id: "Fill-49",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2649336,41.4392817 C23.3208961,41.4189387 22.2490201,41.5918547 22.2490201,42.5479789 C22.2490201,43.1288865 22.6227016,43.4023878 23.0652192,43.4023878 C23.6847439,43.4023878 24.0780928,42.9955264 24.215765,42.5784935 C24.2452662,42.4869497 24.2649336,42.3852344 24.2649336,42.2936906 L24.2649336,41.4392817 Z M24.392772,43.9527808 L24.323936,43.3311871 L24.2944348,43.3311871 C24.0289242,43.7188355 23.5175705,44.0646677 22.8390436,44.0646677 C21.8742459,44.0646677 21.3825597,43.3628318 21.3825597,42.6496943 C21.3825597,41.4596248 22.4063597,40.8086466 24.2452662,40.8188182 L24.2452662,40.7171028 C24.2452662,40.3091113 24.1370952,39.577891 23.1635565,39.577891 C22.7210389,39.577891 22.2588538,39.7202925 21.9234146,39.9440662 L21.7278327,39.3529871 C22.1211817,39.0885272 22.6915377,38.9156111 23.2913949,38.9156111 C24.7467861,38.9156111 25.1018928,39.9440662 25.1018928,40.930705 L25.1018928,42.7717527 C25.1018928,43.2000873 25.1215603,43.6171202 25.17947,43.9527808 L24.392772,43.9527808 Z",
    id: "Fill-50",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4966427,40.3609861 C26.4966427,39.8524094 26.486809,39.4353765 26.4573078,39.027385 L27.2145046,39.027385 L27.2538395,39.8207646 L27.2833407,39.8207646 C27.5488513,39.3528741 27.9913689,38.9154981 28.7780668,38.9154981 C29.4281853,38.9154981 29.9198715,39.3234896 30.1263797,39.9032671 L30.1460471,39.9032671 C30.293553,39.6286357 30.4803938,39.4150334 30.6770683,39.2613303 C30.9622463,39.0386867 31.2769255,38.9154981 31.7303694,38.9154981 C32.3597278,38.9154981 33.2939316,39.3438327 33.2939316,41.0526504 L33.2939316,43.9526678 L32.4482313,43.9526678 L32.4482313,41.1645373 C32.4482313,40.2185846 32.1138847,39.6489787 31.4145976,39.6489787 C30.9229114,39.6489787 30.5393961,40.0253255 30.3918903,40.4627014 C30.3525554,40.5847599 30.3230542,40.7475044 30.3230542,40.9102489 L30.3230542,43.9526678 L29.4773539,43.9526678 L29.4773539,41.0017927 C29.4773539,40.2185846 29.1430073,39.6489787 28.4830551,39.6489787 C27.9422002,39.6489787 27.5488513,40.0965262 27.4111791,40.5440737 C27.3620105,40.6763037 27.342343,40.8288767 27.342343,40.9814497 L27.342343,43.9526678 L26.4966427,43.9526678 L26.4966427,40.3609861 Z",
    id: "Fill-51",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7174687,41.0121903 C37.7273024,40.4425844 37.491293,39.5565308 36.5177543,39.5565308 C35.6425528,39.5565308 35.2590375,40.3917267 35.1902015,41.0121903 L37.7174687,41.0121903 Z M35.1792751,41.652997 C35.1989426,42.8634095 35.9463056,43.3629448 36.812766,43.3629448 C37.4322906,43.3629448 37.8059722,43.2499278 38.1304851,43.1075263 L38.2779909,43.748333 C37.9731455,43.8907344 37.4519581,44.053479 36.6947613,44.053479 C35.2295364,44.053479 34.3532423,43.0566687 34.3532423,41.5716247 C34.3532423,40.0865807 35.1989426,38.9157241 36.5865903,38.9157241 C38.1403188,38.9157241 38.5533352,40.3295674 38.5533352,41.2359641 C38.5533352,41.4190517 38.5347604,41.5614532 38.5238341,41.652997 L35.1792751,41.652997 Z",
    id: "Fill-52",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4178289,43.4335805 C39.4178289,43.0572337 39.7305167,42.7927739 40.1682796,42.7927739 C40.6060426,42.7927739 40.8937154,43.0572337 40.9062229,43.4335805 C40.9062229,43.7895842 40.6185501,44.0642156 40.1557721,44.0642156 C39.7180092,44.0642156 39.4178289,43.7895842 39.4178289,43.4335805 M39.4178289,39.8418988 C39.4178289,39.4655521 39.7305167,39.2010922 40.1682796,39.2010922 C40.6060426,39.2010922 40.8937154,39.4655521 40.9062229,39.8418988 C40.9062229,40.1979025 40.6185501,40.4725339 40.1557721,40.4725339 C39.7180092,40.4725339 39.4178289,40.1979025 39.4178289,39.8418988",
    id: "Fill-53",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1312228,37.0946805 L45.9867568,37.0946805 L45.9867568,41.6831725 C45.9867568,43.5050073 45.1213891,44.0644416 43.9795844,44.0644416 C43.6649052,44.0644416 43.2813899,43.9932409 43.065048,43.9016971 L43.1928864,43.1795182 C43.3698935,43.2507189 43.6266629,43.310618 43.9107483,43.310618 C44.6777788,43.310618 45.1312228,42.9557444 45.1312228,41.6119718 L45.1312228,37.0946805 Z",
    id: "Fill-54",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9140575,41.500537 C47.9140575,42.5787196 48.5139147,43.3924423 49.359615,43.3924423 C50.1867405,43.3924423 50.8051725,42.5888911 50.8051725,41.4801939 C50.8051725,40.6461281 50.4019898,39.5871584 49.3792825,39.5871584 C48.3565751,39.5871584 47.9140575,40.5636257 47.9140575,41.500537 M51.6913004,41.4496793 C51.6913004,43.2703839 50.4708259,44.0648937 49.3202801,44.0648937 C48.0320622,44.0648937 47.0388561,43.0872963 47.0388561,41.5310516 C47.0388561,39.8821329 48.0812309,38.9158372 49.3989499,38.9158372 C50.7658376,38.9158372 51.6913004,39.9442923 51.6913004,41.4496793",
    id: "Fill-55",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7813141,36.7281662 L53.6466818,36.7281662 L53.6466818,39.8010997 L53.6663493,39.8010997 C53.8040214,39.5468113 54.0203634,39.3230376 54.2858739,39.1704646 C54.5415508,39.0178915 54.8474889,38.9161762 55.1720018,38.9161762 C55.8111939,38.9161762 56.8339012,39.3230376 56.8339012,41.0216837 L56.8339012,43.9522157 L55.9685334,43.9522157 L55.9685334,41.1233991 C55.9685334,40.3300194 55.6833554,39.6586982 54.8671563,39.6586982 C54.306634,39.6586982 53.8630238,40.0655595 53.7056842,40.5537932 C53.6565156,40.6758516 53.6466818,40.8080815 53.6466818,40.9809976 L53.6466818,43.9522157 L52.7813141,43.9522157 L52.7813141,36.7281662 Z",
    id: "Fill-56",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2391404,40.3609861 C58.2391404,39.8524094 58.2293067,39.4353765 58.1998055,39.027385 L58.966836,39.027385 L59.0160046,39.8422379 L59.0356721,39.8422379 C59.2716815,39.3732171 59.8223701,38.9154981 60.609068,38.9154981 C61.2690202,38.9154981 62.2917275,39.3234896 62.2917275,41.0119643 L62.2917275,43.9526678 L61.4263598,43.9526678 L61.4263598,41.1136796 C61.4263598,40.3203 61.1411818,39.6580201 60.3249826,39.6580201 C59.753534,39.6580201 59.3110164,40.0761832 59.1635105,40.5745883 C59.1241756,40.6864752 59.1045082,40.8390482 59.1045082,40.9916212 L59.1045082,43.9526678 L58.2391404,43.9526678 L58.2391404,40.3609861 Z",
    id: "Fill-57",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.666533,43.2503799 C66.8828749,43.291066 67.1975541,43.3012375 67.5319008,43.3012375 C69.3620661,43.3012375 70.3552723,42.243398 70.3552723,40.3910486 C70.365106,38.7737747 69.4800708,37.7453196 67.6695729,37.7453196 C67.2270553,37.7453196 66.8927087,37.7871359 66.666533,37.8368634 L66.666533,43.2503799 Z M65.810999,37.1858852 C66.3321864,37.1056431 66.951711,37.0434838 67.630238,37.0434838 C68.8605462,37.0434838 69.7357477,37.3395884 70.3159374,37.8990228 C70.9059609,38.4584572 71.2501412,39.2518368 71.2501412,40.360534 C71.2501412,41.4805329 70.9157946,42.395971 70.29627,43.0266061 C69.6767453,43.6674128 68.654038,44.0132449 67.3647274,44.0132449 C66.7550365,44.0132449 66.2436829,43.9827303 65.810999,43.9318727 L65.810999,37.1858852 Z",
    id: "Fill-58",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9011143,41.500537 C72.9011143,42.5787196 73.5009715,43.3924423 74.3466718,43.3924423 C75.1737973,43.3924423 75.7922293,42.5888911 75.7922293,41.4801939 C75.7922293,40.6461281 75.3890466,39.5871584 74.3663393,39.5871584 C73.3436319,39.5871584 72.9011143,40.5636257 72.9011143,41.500537 M76.6783571,41.4496793 C76.6783571,43.2703839 75.4578827,44.0648937 74.3073369,44.0648937 C73.019119,44.0648937 72.0259128,43.0872963 72.0259128,41.5310516 C72.0259128,39.8821329 73.0682876,38.9158372 74.3860067,38.9158372 C75.7528944,38.9158372 76.6783571,39.9442923 76.6783571,41.4496793",
    id: "Fill-59",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7880891,41.0121903 C80.7979228,40.4425844 80.5619134,39.5565308 79.5883747,39.5565308 C78.7131732,39.5565308 78.329658,40.3917267 78.2608219,41.0121903 L80.7880891,41.0121903 Z M78.2498956,41.652997 C78.269563,42.8634095 79.0169261,43.3629448 79.8833865,43.3629448 C80.5029111,43.3629448 80.8765926,43.2499278 81.2011055,43.1075263 L81.3486114,43.748333 C81.0437659,43.8907344 80.5225785,44.053479 79.7653818,44.053479 C78.3001568,44.053479 77.4238627,43.0566687 77.4238627,41.5716247 C77.4238627,40.0865807 78.269563,38.9157241 79.6572108,38.9157241 C81.2109393,38.9157241 81.6239557,40.3295674 81.6239557,41.2359641 C81.6239557,41.4190517 81.6053809,41.5614532 81.5944545,41.652997 L78.2498956,41.652997 Z",
    id: "Fill-60",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5622475,53.3087838 L17.9132217,51.3355062 C17.7657159,50.8868286 17.6673786,50.4810974 17.5679487,50.0832774 L17.5493739,50.0832774 C17.449944,50.4901387 17.3417731,50.9071716 17.2150273,51.3253347 L16.5649088,53.3087838 L18.5622475,53.3087838 Z M16.3879018,54.0004482 L15.6995411,56.1579435 L14.8145059,56.1579435 L17.0664288,49.3000693 L18.1000625,49.3000693 L20.3618191,56.1579435 L19.4472827,56.1579435 L18.7392546,54.0004482 L16.3879018,54.0004482 Z",
    id: "Fill-61",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4324347,53.2376961 C24.4324347,53.1258092 24.422601,52.9732362 24.3930998,52.8613494 C24.2652614,52.2917435 23.7932426,51.8238529 23.1442168,51.8238529 C22.2482552,51.8238529 21.7183268,52.6375756 21.7183268,53.7259298 C21.7183268,54.7227401 22.1903455,55.5477645 23.1245494,55.5477645 C23.7047391,55.5477645 24.2357602,55.1510747 24.3930998,54.4797534 C24.422601,54.357695 24.4324347,54.2345065 24.4324347,54.092105 L24.4324347,53.2376961 Z M25.2978025,48.9340071 L25.2978025,54.8854846 C25.2978025,55.3239908 25.3076362,55.8223959 25.33823,56.1580566 L24.5602731,56.1580566 L24.5209382,55.3036477 L24.5012708,55.3036477 C24.2357602,55.8529105 23.6555705,56.2699434 22.8787063,56.2699434 C21.7270679,56.2699434 20.8420327,55.2629616 20.8420327,53.7666159 C20.8321989,52.1289989 21.8155714,51.1208869 22.9770435,51.1208869 C23.7047391,51.1208869 24.1964253,51.4780207 24.4127673,51.8747106 L24.4324347,51.8747106 L24.4324347,48.9340071 L25.2978025,48.9340071 Z",
    id: "Fill-62",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9788738,53.2376961 C29.9788738,53.1258092 29.9690401,52.9732362 29.9395389,52.8613494 C29.8117005,52.2917435 29.3396817,51.8238529 28.6906559,51.8238529 C27.7946944,51.8238529 27.2647659,52.6375756 27.2647659,53.7259298 C27.2647659,54.7227401 27.7367847,55.5477645 28.6709885,55.5477645 C29.2511782,55.5477645 29.7821993,55.1510747 29.9395389,54.4797534 C29.9690401,54.357695 29.9788738,54.2345065 29.9788738,54.092105 L29.9788738,53.2376961 Z M30.8442416,48.9340071 L30.8442416,54.8854846 C30.8442416,55.3239908 30.8540753,55.8223959 30.8846691,56.1580566 L30.1067122,56.1580566 L30.0673774,55.3036477 L30.0477099,55.3036477 C29.7821993,55.8529105 29.2020096,56.2699434 28.4251454,56.2699434 C27.273507,56.2699434 26.3884718,55.2629616 26.3884718,53.7666159 C26.378638,52.1289989 27.3620105,51.1208869 28.5234826,51.1208869 C29.2511782,51.1208869 29.7428644,51.4780207 29.9592064,51.8747106 L29.9788738,51.8747106 L29.9788738,48.9340071 L30.8442416,48.9340071 Z",
    id: "Fill-63",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.279419,52.7696925 C32.279419,52.1899151 32.2695853,51.6915099 32.2400841,51.2337909 L32.9972809,51.2337909 L33.0267821,52.2000866 L33.066117,52.2000866 C33.2824589,51.5389369 33.804739,51.1207739 34.3849287,51.1207739 C34.4832659,51.1207739 34.552102,51.1320756 34.6296792,51.1524186 L34.6296792,51.996656 C34.5422683,51.9763129 34.4537648,51.9661414 34.3346674,51.9661414 C33.7249765,51.9661414 33.2922927,52.4442035 33.174288,53.1155247 C33.1546205,53.2375831 33.1349531,53.3811148 33.1349531,53.5325576 L33.1349531,56.1579435 L32.279419,56.1579435 L32.279419,52.7696925 Z",
    id: "Fill-64",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4164279,53.2178051 C38.4262617,52.6481992 38.1902523,51.7621456 37.2167136,51.7621456 C36.3415121,51.7621456 35.9579968,52.5973415 35.8891608,53.2178051 L38.4164279,53.2178051 Z M35.8782344,53.8586118 C35.8979018,55.0690243 36.6452649,55.5685597 37.5117253,55.5685597 C38.1312499,55.5685597 38.5049315,55.4555426 38.8294444,55.3131411 L38.9769502,55.9539478 C38.6721048,56.0963493 38.1509174,56.2590938 37.3937206,56.2590938 C35.9284956,56.2590938 35.0522015,55.2622835 35.0522015,53.7772395 C35.0522015,52.2921955 35.8979018,51.1213389 37.2855496,51.1213389 C38.8392781,51.1213389 39.2522945,52.5351822 39.2522945,53.4415789 C39.2522945,53.6246665 39.2337197,53.767068 39.2227933,53.8586118 L35.8782344,53.8586118 Z",
    id: "Fill-65",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2052917,55.2425055 C40.4609685,55.4154216 40.9133198,55.5985092 41.3460037,55.5985092 C41.9753621,55.5985092 42.2714664,55.2730201 42.2714664,54.8661587 C42.2714664,54.4389543 42.0256233,54.205009 41.3853386,53.959762 C40.5298046,53.6444445 40.1266219,53.1562108 40.1266219,52.5662619 C40.1266219,51.7728822 40.7461465,51.121904 41.7688539,51.121904 C42.251799,51.121904 42.6746491,51.2643055 42.9390671,51.42705 L42.7238178,52.0780282 C42.5358844,51.9559698 42.191704,51.7932253 41.7491864,51.7932253 C41.2378327,51.7932253 40.9526547,52.0983713 40.9526547,52.4645465 C40.9526547,52.8714079 41.2378327,53.0544955 41.8573574,53.2986123 C42.6844829,53.6241014 43.107333,54.0513058 43.107333,54.7847865 C43.107333,55.6493668 42.4583072,56.2596589 41.3263363,56.2596589 C40.8051489,56.2596589 40.3232964,56.1274289 39.9889497,55.9239983 L40.2052917,55.2425055 Z",
    id: "Fill-66",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0993373,55.2425055 C44.3550141,55.4154216 44.8073655,55.5985092 45.2400493,55.5985092 C45.8694077,55.5985092 46.1655121,55.2730201 46.1655121,54.8661587 C46.1655121,54.4389543 45.919669,54.205009 45.2793842,53.959762 C44.4238502,53.6444445 44.0206675,53.1562108 44.0206675,52.5662619 C44.0206675,51.7728822 44.6401921,51.121904 45.6628995,51.121904 C46.1458446,51.121904 46.5676021,51.2643055 46.8331127,51.42705 L46.6178634,52.0780282 C46.42993,51.9559698 46.0857496,51.7932253 45.643232,51.7932253 C45.1318784,51.7932253 44.8467004,52.0983713 44.8467004,52.4645465 C44.8467004,52.8714079 45.1318784,53.0544955 45.751403,53.2986123 C46.5785285,53.6241014 47.0013786,54.0513058 47.0013786,54.7847865 C47.0013786,55.6493668 46.3523528,56.2596589 45.2203819,56.2596589 C44.6991945,56.2596589 44.217342,56.1274289 43.8829954,55.9239983 L44.0993373,55.2425055 Z",
    id: "Fill-67",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9049887,55.6393083 C47.9049887,55.2629616 48.2176765,54.9985017 48.6554394,54.9985017 C49.0932023,54.9985017 49.3808751,55.2629616 49.3933826,55.6393083 C49.3933826,55.995312 49.1057099,56.2699434 48.6429319,56.2699434 C48.205169,56.2699434 47.9049887,55.995312 47.9049887,55.6393083 M47.9049887,52.0476266 C47.9049887,51.6712799 48.2176765,51.40682 48.6554394,51.40682 C49.0932023,51.40682 49.3808751,51.6712799 49.3933826,52.0476266 C49.3933826,52.4036303 49.1057099,52.6782618 48.6429319,52.6782618 C48.205169,52.6782618 47.9049887,52.4036303 47.9049887,52.0476266",
    id: "Fill-68",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-69",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "15.06614 59.7272479 15.636496 59.7272479 15.636496 63.8003822 17.5234784 63.8003822 17.5234784 64.2953968 15.06614 64.2953968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.403269,62.6619615 C18.403269,63.3807499 18.8031738,63.9232317 19.3658813,63.9232317 C19.9165699,63.9232317 20.3295863,63.3875309 20.3295863,62.6483994 C20.3295863,62.0934857 20.0607979,61.3882594 19.3800856,61.3882594 C18.6982807,61.3882594 18.403269,62.0381074 18.403269,62.6619615 M20.9196098,62.6280563 C20.9196098,63.8407292 20.1066886,64.369649 19.3396581,64.369649 C18.4819388,64.369649 17.8198013,63.719801 17.8198013,62.6823045 C17.8198013,61.5837789 18.5147179,60.9407119 19.3921046,60.9407119 C20.3033631,60.9407119 20.9196098,61.6255952 20.9196098,62.6280563",
    id: "Fill-70",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6486166,62.0384464 C21.6486166,61.6519281 21.6420608,61.3207882 21.6223933,61.0156422 L22.1260985,61.0156422 L22.1468586,61.6598393 L22.1719893,61.6598393 C22.3162172,61.2179427 22.6636755,60.9410509 23.0504686,60.9410509 C23.1160268,60.9410509 23.1619175,60.9478319 23.214364,60.961394 L23.214364,61.5230887 C23.1553617,61.5095267 23.0963594,61.5027456 23.0176896,61.5027456 C22.6112289,61.5027456 22.322773,61.8214537 22.2441032,62.2690012 C22.2320842,62.3503735 22.21788,62.4453078 22.21788,62.5470231 L22.21788,64.2953968 L21.6486166,64.2953968 L21.6486166,62.0384464 Z",
    id: "Fill-71",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7380255,62.3369244 C25.7445813,61.9571872 25.5872418,61.3683684 24.9393086,61.3683684 C24.3558409,61.3683684 24.1001641,61.9232821 24.0542734,62.3369244 L25.7380255,62.3369244 Z M24.0477176,62.7629987 C24.0608292,63.5699404 24.5579786,63.9022105 25.1348904,63.9022105 C25.5479069,63.9022105 25.7970279,63.8276193 26.0133698,63.7326849 L26.1117071,64.1598894 C25.9084768,64.2548237 25.5610185,64.3633201 25.0562206,64.3633201 C24.0804966,64.3633201 23.497029,63.6987798 23.497029,62.7098807 C23.497029,61.7198514 24.0608292,60.9411639 24.9851993,60.9411639 C26.0199256,60.9411639 26.2952699,61.8825959 26.2952699,62.4861069 C26.2952699,62.6081653 26.2821583,62.7030997 26.2756025,62.7629987 L24.0477176,62.7629987 Z",
    id: "Fill-72",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0109465,61.903165 C27.0109465,61.5641139 27.0043907,61.286092 26.9847233,61.014851 L27.4884285,61.014851 L27.5146517,61.5437708 L27.5343192,61.5437708 C27.7124189,61.2318438 28.006338,60.9402598 28.5308033,60.9402598 C28.9634871,60.9402598 29.2901853,61.2115007 29.4278575,61.598019 L29.4420617,61.598019 C29.5393063,61.4149314 29.6638669,61.2725299 29.7949832,61.1708146 C29.9851019,61.0216321 30.194888,60.9402598 30.4964555,60.9402598 C30.9160278,60.9402598 31.5388303,61.2250628 31.5388303,62.3642746 L31.5388303,64.2957359 L30.9750301,64.2957359 L30.9750301,62.4388658 C30.9750301,61.8082307 30.7521324,61.4284934 30.2866694,61.4284934 C29.9588786,61.4284934 29.7032018,61.6793913 29.6059571,61.9709752 C29.5797339,62.0523475 29.5600664,62.1608439 29.5600664,62.2693402 L29.5600664,64.2957359 L28.9962662,64.2957359 L28.9962662,62.3292393 C28.9962662,61.8082307 28.7733685,61.4284934 28.3341288,61.4284934 C27.9735589,61.4284934 27.7124189,61.7268584 27.6206374,62.0252234 C27.5867657,62.1133767 27.5747467,62.2150921 27.5747467,62.3168074 L27.5747467,64.2957359 L27.0109465,64.2957359 L27.0109465,61.903165 Z",
    id: "Fill-73",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-74",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "33.8870145 64.2953968 34.4573705 64.2953968 34.4573705 59.7272479 33.8870145 59.7272479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0705383,62.9605525 C36.0705383,63.0487058 36.08365,63.1300781 36.0967616,63.2046693 C36.2016547,63.6183117 36.5491129,63.9019845 36.9610367,63.9019845 C37.5707276,63.9019845 37.9247417,63.3866268 37.9247417,62.6350634 C37.9247417,61.9773042 37.5903951,61.4144793 36.9807042,61.4144793 C36.5884478,61.4144793 36.2213221,61.7071935 36.1098732,62.1536108 C36.0902058,62.228202 36.0705383,62.3163553 36.0705383,62.3977276 L36.0705383,62.9605525 Z M35.501275,62.0858006 C35.501275,61.6653772 35.4870707,61.3274562 35.4739591,61.0155291 L35.9918685,61.0155291 L36.0180918,61.5772239 L36.0312034,61.5772239 C36.2672128,61.1782737 36.6398017,60.9409379 37.1588038,60.9409379 C37.9247417,60.9409379 38.5016535,61.6122591 38.5016535,62.6079393 C38.5016535,63.7867071 37.806737,64.369875 37.059374,64.369875 C36.6398017,64.369875 36.2737686,64.1800064 36.08365,63.8556475 L36.0705383,63.8556475 L36.0705383,65.6379263 L35.501275,65.6379263 L35.501275,62.0858006 Z",
    id: "Fill-75",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1520998,63.6856699 C39.322551,63.8009472 39.6241186,63.9230056 39.9125745,63.9230056 C40.3321467,63.9230056 40.5277286,63.7060129 40.5277286,63.434772 C40.5277286,63.1499691 40.3638332,62.9940055 39.9387977,62.831261 C39.3684417,62.6221795 39.0996533,62.2966904 39.0996533,61.9033911 C39.0996533,61.3744713 39.5126697,60.9404858 40.1944746,60.9404858 C40.5157096,60.9404858 40.796517,61.0354201 40.9735241,61.1439165 L40.8292961,61.577902 C40.7047356,61.4965297 40.475282,61.3880333 40.1802703,61.3880333 C39.8404605,61.3880333 39.6503418,61.591464 39.6503418,61.8355808 C39.6503418,62.1068217 39.8404605,62.22775 40.2523843,62.3904945 C40.8030729,62.6074872 41.084973,62.8922902 41.084973,63.3805238 C41.084973,63.9569108 40.6533817,64.3637721 39.8994628,64.3637721 C39.5520046,64.3637721 39.2307696,64.2744887 39.0078718,64.1399984 L39.1520998,63.6856699 Z",
    id: "Fill-76",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4803395,63.4008669 C44.4803395,63.739918 44.4868953,64.0371529 44.5065628,64.2959619 L43.9963017,64.2959619 L43.96243,63.7602611 L43.950411,63.7602611 C43.7985346,64.024721 43.4652806,64.369423 42.9014804,64.369423 C42.4032384,64.369423 41.8077517,64.08462 41.8077517,62.9329763 L41.8077517,61.0150771 L42.3835709,61.0150771 L42.3835709,62.831261 C42.3835709,63.4551151 42.5671338,63.8755385 43.0915991,63.8755385 C43.4783922,63.8755385 43.7471807,63.5975166 43.8509811,63.3330567 C43.8848528,63.2449034 43.9045203,63.136407 43.9045203,63.0279107 L43.9045203,61.0150771 L44.4803395,61.0150771 L44.4803395,63.4008669 Z",
    id: "Fill-77",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4395647,61.903165 C45.4395647,61.5641139 45.4330089,61.286092 45.4133414,61.014851 L45.9170466,61.014851 L45.9432699,61.5437708 L45.9629373,61.5437708 C46.141037,61.2318438 46.4349561,60.9402598 46.9594214,60.9402598 C47.3921053,60.9402598 47.7188035,61.2115007 47.8564756,61.598019 L47.8706799,61.598019 C47.9679245,61.4149314 48.092485,61.2725299 48.2236013,61.1708146 C48.41372,61.0216321 48.6235061,60.9402598 48.9250737,60.9402598 C49.3446459,60.9402598 49.9674485,61.2250628 49.9674485,62.3642746 L49.9674485,64.2957359 L49.4036483,64.2957359 L49.4036483,62.4388658 C49.4036483,61.8082307 49.1807505,61.4284934 48.7152876,61.4284934 C48.3874967,61.4284934 48.1318199,61.6793913 48.0345753,61.9709752 C48.008352,62.0523475 47.9886846,62.1608439 47.9886846,62.2693402 L47.9886846,64.2957359 L47.4248844,64.2957359 L47.4248844,62.3292393 C47.4248844,61.8082307 47.2019866,61.4284934 46.7627469,61.4284934 C46.402177,61.4284934 46.141037,61.7268584 46.0492556,62.0252234 C46.0153839,62.1133767 46.0033649,62.2150921 46.0033649,62.3168074 L46.0033649,64.2957359 L45.4395647,64.2957359 L45.4395647,61.903165 Z",
    id: "Fill-78",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8863164,63.8280713 C53.0305444,63.8551954 53.2403305,63.8619764 53.4632282,63.8619764 C54.6815174,63.8619764 55.3436549,63.1567501 55.3436549,61.9237341 C55.3502107,60.8455515 54.7601872,60.1606682 53.5550097,60.1606682 C53.2599979,60.1606682 53.0371002,60.1889225 52.8863164,60.2228276 L52.8863164,63.8280713 Z M52.3159604,59.7888421 C52.6634187,59.734594 53.0764351,59.6939078 53.5276938,59.6939078 C54.3471708,59.6939078 54.9306385,59.8905575 55.3174316,60.2635137 C55.709688,60.6353398 55.9391415,61.1642596 55.9391415,61.9033911 C55.9391415,62.6493036 55.7162438,63.2584654 55.30432,63.6788888 C54.8913036,64.1060933 54.2094987,64.336648 53.3517794,64.336648 C52.9453188,64.336648 52.6044163,64.316305 52.3159604,64.2812697 L52.3159604,59.7888421 Z",
    id: "Fill-79",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0429225,62.6619615 C57.0429225,63.3807499 57.4428273,63.9232317 58.0055348,63.9232317 C58.5562234,63.9232317 58.9692398,63.3875309 58.9692398,62.6483994 C58.9692398,62.0934857 58.7004514,61.3882594 58.0197391,61.3882594 C57.3379342,61.3882594 57.0429225,62.0381074 57.0429225,62.6619615 M59.5592633,62.6280563 C59.5592633,63.8407292 58.7463421,64.369649 57.9793116,64.369649 C57.1215923,64.369649 56.4594548,63.719801 56.4594548,62.6823045 C56.4594548,61.5837789 57.1543713,60.9407119 58.0317581,60.9407119 C58.9430166,60.9407119 59.5592633,61.6255952 59.5592633,62.6280563",
    id: "Fill-80",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-81",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "60.2883793 64.2953968 60.8641985 64.2953968 60.8641985 59.483131 60.2883793 59.483131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1892383,62.6619615 C62.1892383,63.3807499 62.5891431,63.9232317 63.1518506,63.9232317 C63.7025392,63.9232317 64.1155556,63.3875309 64.1155556,62.6483994 C64.1155556,62.0934857 63.8467672,61.3882594 63.1660549,61.3882594 C62.48425,61.3882594 62.1892383,62.0381074 62.1892383,62.6619615 M64.7055791,62.6280563 C64.7055791,63.8407292 63.8926579,64.369649 63.1256274,64.369649 C62.2679081,64.369649 61.6057706,63.719801 61.6057706,62.6823045 C61.6057706,61.5837789 62.3006871,60.9407119 63.1780739,60.9407119 C64.0893324,60.9407119 64.7055791,61.6255952 64.7055791,62.6280563",
    id: "Fill-82",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4345859,62.0384464 C65.4345859,61.6519281 65.42803,61.3207882 65.4083626,61.0156422 L65.9120678,61.0156422 L65.9328279,61.6598393 L65.9579585,61.6598393 C66.1021865,61.2179427 66.4496448,60.9410509 66.8364379,60.9410509 C66.9019961,60.9410509 66.9478868,60.9478319 67.0003333,60.961394 L67.0003333,61.5230887 C66.941331,61.5095267 66.8823286,61.5027456 66.8036588,61.5027456 C66.3971982,61.5027456 66.1098349,61.8214537 66.0300725,62.2690012 C66.0180535,62.3503735 66.0038492,62.4453078 66.0038492,62.5470231 L66.0038492,64.2953968 L65.4345859,64.2953968 L65.4345859,62.0384464 Z",
    id: "Fill-83",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9088407,63.5769475 C69.1645175,63.739692 69.5381991,63.8753125 69.9315481,63.8753125 C70.5139231,63.8753125 70.8548255,63.5566044 70.8548255,63.0954948 C70.8548255,62.6694206 70.6188161,62.4241736 70.0233295,62.187968 C69.3021897,61.9235081 68.8563942,61.5369898 68.8563942,60.8927926 C68.8563942,60.1819154 69.4267502,59.6529957 70.2844695,59.6529957 C70.7368208,59.6529957 71.0646116,59.761492 71.2612861,59.8767694 L71.1039465,60.358222 C70.9597186,60.2768497 70.6647068,60.1412293 70.264802,60.1412293 C69.6616669,60.1412293 69.433306,60.5141855 69.433306,60.8249824 C69.433306,61.2521868 69.7020945,61.4623985 70.3106928,61.7065154 C71.0580558,62.0048804 71.4382932,62.3767064 71.4382932,63.0480277 C71.4382932,63.753254 70.9334953,64.3635461 69.8911205,64.3635461 C69.4660851,64.3635461 69.0006221,64.2347067 68.7646128,64.0719621 L68.9088407,63.5769475 Z",
    id: "Fill-84",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2295067,64.2953968 L73.0350753,64.2953968 L73.0350753,61.0156422 L72.2295067,61.0156422 L72.2295067,64.2953968 Z M73.1267909,60.0934231 C73.1359625,60.2968538 72.9341882,60.4595983 72.6131836,60.4595983 C72.3303938,60.4595983 72.1270909,60.2968538 72.1270909,60.0934231 C72.1270909,59.8832114 72.3395654,59.7204668 72.6315267,59.7204668 C72.9341882,59.7204668 73.1267909,59.8832114 73.1267909,60.0934231 Z",
    id: "Fill-85",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4280732,60.073306 L74.4280732,61.014738 L75.254106,61.014738 L75.254106,61.4690666 L74.4280732,61.4690666 L74.4280732,63.2377833 C74.4280732,63.6446447 74.5395221,63.8751994 74.8607571,63.8751994 C75.0115408,63.8751994 75.1229897,63.8548564 75.1951037,63.8345133 L75.221327,64.2820608 C75.1098781,64.329528 74.932871,64.3634331 74.7099733,64.3634331 C74.4411848,64.3634331 74.2248429,64.2752798 74.0871707,64.1125352 C73.924368,63.9362286 73.864273,63.6446447 73.864273,63.2581264 L73.864273,61.4690666 L73.3736794,61.4690666 L73.3736794,61.014738 L73.864273,61.014738 L73.864273,60.2292696 L74.4280732,60.073306 Z",
    id: "Fill-86",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2284667,70.5345028 L16.7957828,69.2201145 C16.6974456,68.9217495 16.6329801,68.6505086 16.5674219,68.3860487 L16.5532176,68.3860487 C16.4876595,68.6572897 16.4155455,68.9353116 16.3314125,69.2133335 L15.8987286,70.5345028 L17.2284667,70.5345028 Z M15.7807239,70.9956123 L15.3218168,72.432059 L14.7317933,72.432059 L16.2319826,67.86391 L16.9203433,67.86391 L18.4281811,72.432059 L17.8184902,72.432059 L17.3464714,70.9956123 L15.7807239,70.9956123 Z",
    id: "Fill-87",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0391832,70.0400532 C19.0391832,69.7010021 19.0326274,69.4229801 19.0129599,69.1517392 L19.5166651,69.1517392 L19.5428884,69.680659 L19.5625558,69.680659 C19.7406555,69.368732 20.0345746,69.077148 20.5590399,69.077148 C20.9917238,69.077148 21.318422,69.3483889 21.4560941,69.7349072 L21.4702984,69.7349072 C21.567543,69.5518196 21.6921035,69.4094181 21.8232198,69.3077027 C22.0133385,69.1585202 22.2231246,69.077148 22.5246922,69.077148 C22.9442644,69.077148 23.567067,69.3619509 23.567067,70.5011627 L23.567067,72.432624 L23.0032668,72.432624 L23.0032668,70.575754 C23.0032668,69.9451189 22.780369,69.5653816 22.314906,69.5653816 C21.9871152,69.5653816 21.7314384,69.8162794 21.6341938,70.1078634 C21.6079705,70.1892357 21.5883031,70.2977321 21.5883031,70.4062284 L21.5883031,72.432624 L21.0245029,72.432624 L21.0245029,70.4661275 C21.0245029,69.9451189 20.8016051,69.5653816 20.3623654,69.5653816 C20.0017955,69.5653816 19.7406555,69.8637466 19.6488741,70.1621116 C19.6150024,70.2502649 19.6029834,70.3519802 19.6029834,70.4536956 L19.6029834,72.432624 L19.0391832,72.432624 L19.0391832,70.0400532 Z",
    id: "Fill-88",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5179491,70.4738126 C26.524505,70.0940753 26.3671654,69.5041264 25.7192322,69.5041264 C25.1357645,69.5041264 24.8800877,70.0601702 24.834197,70.4738126 L26.5179491,70.4738126 Z M24.8276412,70.8998869 C24.8407528,71.7068286 25.3379022,72.0390987 25.914814,72.0390987 C26.3278305,72.0390987 26.5769515,71.9645074 26.7932934,71.8695731 L26.8916307,72.2967775 C26.6884004,72.3917119 26.3409421,72.5002082 25.8361442,72.5002082 C24.8604203,72.5002082 24.2769526,71.835668 24.2769526,70.8467689 C24.2769526,69.8567396 24.8407528,69.0780521 25.7651229,69.0780521 C26.7998492,69.0780521 27.0751935,70.0194841 27.0751935,70.6229951 C27.0751935,70.7450535 27.0620819,70.8399878 27.0555261,70.8998869 L24.8276412,70.8998869 Z",
    id: "Fill-89",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4850218,68.2101942 L28.4850218,69.1516262 L29.3110547,69.1516262 L29.3110547,69.6059547 L28.4850218,69.6059547 L28.4850218,71.3746715 C28.4850218,71.7815328 28.5964707,72.0120876 28.9177057,72.0120876 C29.0684895,72.0120876 29.1799384,71.9917445 29.2520523,71.9714015 L29.2782756,72.418949 C29.1668267,72.4664161 28.9898197,72.5003212 28.7669219,72.5003212 C28.4981335,72.5003212 28.2817915,72.412168 28.1441194,72.2494234 C27.9813166,72.0731168 27.9212216,71.7815328 27.9212216,71.3950145 L27.9212216,69.6059547 L27.430628,69.6059547 L27.430628,69.1516262 L27.9212216,69.1516262 L27.9212216,68.3661577 L28.4850218,68.2101942 Z",
    id: "Fill-90",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7170393,70.1753346 C31.7170393,71.1518019 32.2283929,72.0254236 33.1265398,72.0254236 C34.0301498,72.0254236 34.5415034,71.1642337 34.5415034,70.1278674 C34.5415034,69.2203406 34.0825963,68.2709974 33.1320029,68.2709974 C32.189058,68.2709974 31.7170393,69.1728734 31.7170393,70.1753346 M35.1435459,70.1007434 C35.1435459,71.6728104 34.2202684,72.5068762 33.092668,72.5068762 C31.9268254,72.5068762 31.1073483,71.5710951 31.1073483,70.1888966 C31.1073483,68.738888 31.9792719,67.7895448 33.1582262,67.7895448 C34.3644964,67.7895448 35.1435459,68.745669 35.1435459,70.1007434",
    id: "Fill-91",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8864292,72.432285 L35.8864292,67.864136 L36.5092317,67.864136 L37.9241954,70.1753346 C38.2519862,70.7110354 38.507663,71.192488 38.7174492,71.6592484 L38.7305608,71.6535975 C38.6781143,71.0433055 38.6650026,70.4872616 38.6650026,69.7752543 L38.6650026,67.864136 L39.2025796,67.864136 L39.2025796,72.432285 L38.6256677,72.432285 L37.2238157,70.1143054 C36.9156923,69.6068589 36.6206806,69.0847201 36.3977828,68.5897055 L36.3781154,68.5964865 C36.4108945,69.1728734 36.4240061,69.7221363 36.4240061,70.4804806 L36.4240061,72.432285 L35.8864292,72.432285 Z",
    id: "Fill-92",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0430352,72.0796718 C40.0430352,71.828774 40.2069306,71.6535975 40.4352916,71.6535975 C40.6647451,71.6535975 40.8220847,71.828774 40.8220847,72.0796718 C40.8220847,72.3237886 40.6723936,72.5068762 40.4298284,72.5068762 C40.2003748,72.5068762 40.0430352,72.3237886 40.0430352,72.0796718",
    id: "Fill-93",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.032866,72.2833285 C45.8230799,72.3918249 45.4035077,72.5003212 44.8670234,72.5003212 C43.6214183,72.5003212 42.6850292,71.6865985 42.6850292,70.1891227 C42.6850292,68.7594571 43.6214183,67.7897708 44.9904913,67.7897708 C45.5411798,67.7897708 45.8886381,67.9118292 46.0394219,67.9932015 L45.9017497,68.4746541 C45.6854078,68.3661577 45.3772844,68.2847855 45.0101587,68.2847855 C43.9754324,68.2847855 43.2870717,68.9685386 43.2870717,70.1687796 C43.2870717,71.2865182 43.9098742,72.0053066 44.9850281,72.0053066 C45.3313937,72.0053066 45.6854078,71.9307153 45.9148614,71.815438 L46.032866,72.2833285 Z",
    id: "Fill-94",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9373112,70.5345028 L48.5046273,69.2201145 C48.4062901,68.9217495 48.3418245,68.6505086 48.2762664,68.3860487 L48.2620621,68.3860487 C48.196504,68.6572897 48.12439,68.9353116 48.040257,69.2133335 L47.6075731,70.5345028 L48.9373112,70.5345028 Z M47.4895684,70.9956123 L47.0306613,72.432059 L46.4406378,72.432059 L47.9408271,67.86391 L48.6291878,67.86391 L50.1370256,72.432059 L49.5273347,72.432059 L49.0553159,70.9956123 L47.4895684,70.9956123 Z",
    id: "Fill-95",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7870348,72.432285 L50.7870348,67.864136 L51.4098373,67.864136 L52.824801,70.1753346 C53.1525918,70.7110354 53.4082686,71.192488 53.6180548,71.6592484 L53.6311664,71.6535975 C53.5787199,71.0433055 53.5656082,70.4872616 53.5656082,69.7752543 L53.5656082,67.864136 L54.1031852,67.864136 L54.1031852,72.432285 L53.5262733,72.432285 L52.1244213,70.1143054 C51.8162979,69.6068589 51.5212862,69.0847201 51.2983884,68.5897055 L51.278721,68.5964865 C51.3115001,69.1728734 51.3246117,69.7221363 51.3246117,70.4804806 L51.3246117,72.432285 L50.7870348,72.432285 Z",
    id: "Fill-96",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2627608,70.5345028 L56.830077,69.2201145 C56.7317397,68.9217495 56.6672742,68.6505086 56.601716,68.3860487 L56.5875118,68.3860487 C56.5219536,68.6572897 56.4498396,68.9353116 56.3657066,69.2133335 L55.9330228,70.5345028 L57.2627608,70.5345028 Z M55.8150181,70.9956123 L55.3561109,72.432059 L54.7660875,72.432059 L56.2662768,67.86391 L56.9546375,67.86391 L58.4624752,72.432059 L57.8527843,72.432059 L57.3807655,70.9956123 L55.8150181,70.9956123 Z",
    id: "Fill-97",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6828404,71.9649595 C59.8270684,71.9920836 60.0368545,71.9988646 60.2597523,71.9988646 C61.4780415,71.9988646 62.1401789,71.2936383 62.1401789,70.0606223 C62.1467347,68.9824397 61.5567113,68.2975564 60.3515337,68.2975564 C60.056522,68.2975564 59.8336242,68.3258107 59.6828404,68.3597158 L59.6828404,71.9649595 Z M59.1124844,67.9257303 C59.4599427,67.8714821 59.8729591,67.830796 60.3242178,67.830796 C61.1436948,67.830796 61.7271625,68.0274457 62.1139556,68.4004019 C62.506212,68.772228 62.7356656,69.3011478 62.7356656,70.0402792 C62.7356656,70.7861917 62.5127678,71.3953536 62.100844,71.815777 C61.6878276,72.2429814 61.0060227,72.4735362 60.1483034,72.4735362 C59.7418428,72.4735362 59.4009403,72.4531931 59.1124844,72.4181579 L59.1124844,67.9257303 Z",
    id: "Fill-98",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5493126,70.5345028 L65.1166288,69.2201145 C65.0182915,68.9217495 64.953826,68.6505086 64.8882678,68.3860487 L64.8740636,68.3860487 C64.8085054,68.6572897 64.7363914,68.9353116 64.6522584,69.2133335 L64.2195746,70.5345028 L65.5493126,70.5345028 Z M64.1015699,70.9956123 L63.6426627,72.432059 L63.0526393,72.432059 L64.5528286,67.86391 L65.2411893,67.86391 L66.749027,72.432059 L66.1393361,72.432059 L65.6673173,70.9956123 L64.1015699,70.9956123 Z",
    id: "Fill-99",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2284667,78.671956 L16.7957828,77.3575678 C16.6974456,77.0592028 16.6329801,76.7879619 16.5674219,76.523502 L16.5532176,76.523502 C16.4876595,76.7947429 16.4155455,77.0727648 16.3314125,77.3507868 L15.8987286,78.671956 L17.2284667,78.671956 Z M15.7807239,79.1330656 L15.3218168,80.5695122 L14.7317933,80.5695122 L16.2319826,76.0013633 L16.9203433,76.0013633 L18.4281811,80.5695122 L17.8184902,80.5695122 L17.3464714,79.1330656 L15.7807239,79.1330656 Z",
    id: "Fill-100",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-101",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    points: "20.1264653 76.7201517 20.1133537 76.7201517 19.3736391 77.1337941 19.2610976 76.6794655 20.1920235 76.1641078 20.6837097 76.1641078 20.6837097 80.5695122 20.1264653 80.5695122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0116801,80.1221908 C23.1231289,80.1425338 23.2870243,80.1493148 23.489162,80.1493148 C24.0802781,80.1493148 24.6233182,79.9255411 24.6233182,79.262131 C24.6233182,78.638277 24.1054087,78.3805981 23.4836988,78.3805981 L23.0116801,78.3805981 L23.0116801,80.1221908 Z M23.0116801,77.9330506 L23.5295895,77.9330506 C24.131632,77.9330506 24.4856461,77.6075615 24.4856461,77.1679252 C24.4856461,76.6322244 24.0922971,76.4220127 23.5153853,76.4220127 C23.2542453,76.4220127 23.1034615,76.4423558 23.0116801,76.4626988 L23.0116801,77.9330506 Z M22.441324,76.0626185 C22.6904451,76.0083703 23.083794,75.9676842 23.4836988,75.9676842 C24.0540548,75.9676842 24.4200879,76.0693995 24.6954322,76.2999543 C24.9248858,76.4762609 25.0625579,76.7475018 25.0625579,77.106896 C25.0625579,77.5476625 24.7806578,77.9330506 24.3151949,78.1093572 L24.3151949,78.1229192 C24.7347671,78.2314156 25.2264533,78.5908098 25.2264533,79.2689121 C25.2264533,79.6610812 25.0756696,79.9594462 24.8527718,80.18322 C24.5446484,80.4748039 24.0464064,80.6104244 23.3263592,80.6104244 C22.9330103,80.6104244 22.6314427,80.5833003 22.441324,80.5561762 L22.441324,76.0626185 Z",
    id: "Fill-102",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1817255,80.5697382 L27.1817255,80.203563 L27.6340769,79.7492345 C28.7212497,78.6789631 29.212936,78.1093572 29.2194918,77.444817 C29.2194918,76.9983996 29.0097057,76.5847572 28.3737915,76.5847572 C27.9869983,76.5847572 27.6657633,76.7881879 27.4701815,76.9577135 L27.2866186,76.5372901 C27.5816303,76.2796112 28.0012026,76.0897426 28.4917962,76.0897426 C29.4096104,76.0897426 29.7964036,76.7407208 29.7964036,77.3702257 C29.7964036,78.1839484 29.2260476,78.8417076 28.3279008,79.7356725 L27.9869983,80.0611615 L27.9869983,80.0747236 L29.900204,80.0747236 L29.900204,80.5697382 L27.1817255,80.5697382 Z",
    id: "Fill-103",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8340216,80.4207818 C33.6242355,80.5292781 33.2046632,80.6377745 32.6681789,80.6377745 C31.4225738,80.6377745 30.4861847,79.8240518 30.4861847,78.3265759 C30.4861847,76.8969103 31.4225738,75.9272241 32.7916468,75.9272241 C33.3423354,75.9272241 33.6897936,76.0492825 33.8405774,76.1306548 L33.7029053,76.6121074 C33.4865633,76.503611 33.17844,76.4222387 32.8113143,76.4222387 C31.7765879,76.4222387 31.0882272,77.1059919 31.0882272,78.3062329 C31.0882272,79.4239714 31.7110298,80.1427599 32.7861836,80.1427599 C33.1325493,80.1427599 33.4865633,80.0681686 33.7160169,79.9528912 L33.8340216,80.4207818 Z",
    id: "Fill-104",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4849049,79.8855331 C34.6488003,79.9940294 35.0290377,80.163555 35.4278498,80.163555 C36.1686571,80.163555 36.3981106,79.6753214 36.3915548,79.3091461 C36.384999,78.6920731 35.8474221,78.4276132 35.2901777,78.4276132 L34.9689427,78.4276132 L34.9689427,77.9811959 L35.2901777,77.9811959 C35.7097499,77.9811959 36.240771,77.7574221 36.240771,77.2352834 C36.240771,76.8826702 36.0244291,76.5707431 35.493408,76.5707431 C35.1525055,76.5707431 34.8258073,76.7278368 34.6422445,76.8623271 L34.4914607,76.4283417 C34.7132658,76.2599463 35.1459497,76.0904207 35.6048569,76.0904207 C36.4440013,76.0904207 36.8242387,76.6046482 36.8242387,77.140349 C36.8242387,77.5946776 36.562006,77.9811959 36.0375407,78.1778455 L36.0375407,78.1902774 C36.562006,78.2999039 36.9881341,78.7067653 36.9881341,79.3227082 C36.9881341,80.0279345 36.457113,80.6438774 35.4344056,80.6438774 C34.9569237,80.6438774 34.5373514,80.4890441 34.3275653,80.3466426 L34.4849049,79.8855331 Z",
    id: "Fill-105",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProofOfAddress);
export default __webpack_public_path__ + "static/media/proof_of_address.a49091ae75073ee2eacbffeafcaace4f.svg";
export { ForwardRef as ReactComponent };